import { baseReducer as BaseReducer } from '../../store/core/base-reducer';
import { OrderDrawerSection } from '../../enums/order-drawer-section';

import * as Actions from './sidebar-errors-and-warnings.actions';

const ALL_SECTIONS = 'all-sections';

const initialState = () => {
  const intlState = {};

  Object.keys(OrderDrawerSection).forEach((key) => {
    intlState[key] = [];
  });

  return intlState;
};

const actionHandlerMap = {
  [Actions.SIDEBAR_ERRORS_SET_ERRORS]: (state, { errorList, sectionId }) => {
    return {
      ...state,
      [sectionId]: errorList,
    };
  },
  [Actions.SIDEBAR_ERRORS_CLEAR_ERRORS]: (state, { sectionId }) => {
    if (sectionId === ALL_SECTIONS) {
      return initialState();
    }

    return {
      ...state,
      [sectionId]: [],
    };
  },
};

export const ConnectedActionHandlerMap = BaseReducer(initialState(), actionHandlerMap);

export { namespace } from './sidebar-errors-and-warnings.reducer.metadata';
